function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 16a1 1 0 0 1 1 1v4.586L28.586 13 20 4.414V9a1 1 0 0 1-1 1c-8.548 0-13.632 4.133-15.345 12.636C6.613 18.229 11.764 16 19 16zM2.988 30.152C2.801 31.372 1 31.235 1 30 1 15.9 6.724 8.43 18 8.018v-4.81a1.5 1.5 0 0 1 2.56-1.062l9.794 9.793a1.5 1.5 0 0 1 0 2.122l-9.793 9.793A1.5 1.5 0 0 1 18 22.793v-4.778c-8.895.274-13.802 4.273-15.012 12.137z"
});

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "b5f684f65f05cd60cf0db0ccfaf0d43d.svg";
export { SvgShare as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/share.svg
// module id = null
// module chunks = 